module.exports = __webpack_public_path__ + "e600a9d594795eefbc74e1bc590647c2.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/home.svg
// module id = s2D/
// module chunks = 0